import { useTranslation } from '../../i18n/LanguageContext'
import './HeroTitle.css'

const HeroTitle = () => {
  const { t } = useTranslation()
  return (
    <div className="hero__title-wrapper">
      <h1 className="hero__title">
        <span className="hero__title-letter">{t('hero.titleLetter')}</span>{t('hero.titleRest')}
        <br />
        {t('hero.titleIn')} <span className="hero__title-highlight">TibiaME</span>
      </h1>
    </div>
  )
}

export default HeroTitle
